.actionButton {
  padding: 0.375rem;
  min-width: 0rem !important;
  width: unset;
  min-height: 0rem !important;
  height: unset;
  color: var(--pm-grey4) !important;
  gap: 0.25rem;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.42px;
  border: 1.5px solid var(--pm-border) !important;
  border-radius: 10px !important;
}

.textButton {
  padding-right: 0.75rem !important;
}

.textOnlyButton {
  padding-left: 0.75rem !important;
}

.iconRight {
  padding-left: 1rem !important;
  padding-right: 0.5625rem !important;
}
